var map = {
	"./111.png": "./src/assets/111.png",
	"./Combinationphoto1.jpg": "./src/assets/Combinationphoto1.jpg",
	"./Combinationphoto2.jpg": "./src/assets/Combinationphoto2.jpg",
	"./UNAFold_favicon.png": "./src/assets/UNAFold_favicon.png",
	"./WeChat.png": "./src/assets/WeChat.png",
	"./aptamer-example.png": "./src/assets/aptamer-example.png",
	"./aptamer_logo.png": "./src/assets/aptamer_logo.png",
	"./aptamertype.png": "./src/assets/aptamertype.png",
	"./arrow-down.png": "./src/assets/arrow-down.png",
	"./arrow-up.png": "./src/assets/arrow-up.png",
	"./article_demo_img.png": "./src/assets/article_demo_img.png",
	"./batchUpload.png": "./src/assets/batchUpload.png",
	"./book.png": "./src/assets/book.png",
	"./circle.jpg": "./src/assets/circle.jpg",
	"./circle.png": "./src/assets/circle.png",
	"./clock.png": "./src/assets/clock.png",
	"./close.png": "./src/assets/close.png",
	"./comment.png": "./src/assets/comment.png",
	"./css/common.less": "./src/assets/css/common.less",
	"./css/list-pager@index.less": "./src/assets/css/list-pager@index.less",
	"./css/list.less": "./src/assets/css/list.less",
	"./delete.png": "./src/assets/delete.png",
	"./ding.png": "./src/assets/ding.png",
	"./evaluationaffinity.png": "./src/assets/evaluationaffinity.png",
	"./evaluationbgimg.png": "./src/assets/evaluationbgimg.png",
	"./evaluationlength.png": "./src/assets/evaluationlength.png",
	"./evaluationname.png": "./src/assets/evaluationname.png",
	"./evaluationscore.png": "./src/assets/evaluationscore.png",
	"./evaluationsimilar.png": "./src/assets/evaluationsimilar.png",
	"./evaluationtarget.png": "./src/assets/evaluationtarget.png",
	"./filterbgimg.png": "./src/assets/filterbgimg.png",
	"./fork.png": "./src/assets/fork.png",
	"./frontpage-main.png": "./src/assets/frontpage-main.png",
	"./frontpage-team.png": "./src/assets/frontpage-team.png",
	"./image001.jpg": "./src/assets/image001.jpg",
	"./image002.jpg": "./src/assets/image002.jpg",
	"./image003.jpg": "./src/assets/image003.jpg",
	"./image004.jpg": "./src/assets/image004.jpg",
	"./image005.jpg": "./src/assets/image005.jpg",
	"./intro-1.png": "./src/assets/intro-1.png",
	"./intro-2.png": "./src/assets/intro-2.png",
	"./intro-3.png": "./src/assets/intro-3.png",
	"./intro-4.png": "./src/assets/intro-4.png",
	"./intro-5.png": "./src/assets/intro-5.png",
	"./lab.png": "./src/assets/lab.png",
	"./language.png": "./src/assets/language.png",
	"./left.png": "./src/assets/left.png",
	"./loading.png": "./src/assets/loading.png",
	"./logo.png": "./src/assets/logo.png",
	"./message.png": "./src/assets/message.png",
	"./micro-blog.png": "./src/assets/micro-blog.png",
	"./more.png": "./src/assets/more.png",
	"./newest.png": "./src/assets/newest.png",
	"./nodata.png": "./src/assets/nodata.png",
	"./nodata2.png": "./src/assets/nodata2.png",
	"./nupack_favicon.png": "./src/assets/nupack_favicon.png",
	"./patent_demo_img.png": "./src/assets/patent_demo_img.png",
	"./position.png": "./src/assets/position.png",
	"./prev-left.png": "./src/assets/prev-left.png",
	"./prev-right.png": "./src/assets/prev-right.png",
	"./recommendscore.png": "./src/assets/recommendscore.png",
	"./remove.png": "./src/assets/remove.png",
	"./right.png": "./src/assets/right.png",
	"./screenmethod.png": "./src/assets/screenmethod.png",
	"./search.png": "./src/assets/search.png",
	"./search2.png": "./src/assets/search2.png",
	"./sequence-default.png": "./src/assets/sequence-default.png",
	"./sequence-default2.png": "./src/assets/sequence-default2.png",
	"./ss.png": "./src/assets/ss.png",
	"./targetname.png": "./src/assets/targetname.png",
	"./team.png": "./src/assets/team.png",
	"./user.png": "./src/assets/user.png",
	"./导出.png": "./src/assets/导出.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";